import React from 'react';
import { FooterWrapper, TollFreeNumber, Number } from './styles';

function footer() {
    return (
        <FooterWrapper>
            <TollFreeNumber>Toll Free Number:</TollFreeNumber>
            <Number>1800-266-2256</Number>
        </FooterWrapper>
    );
}

export default footer;
